var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5ExpandCollapse = function SvgAv5ExpandCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "regular",
    viewBox: "6 6 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9B9AC8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "av5_expandCollapse_svg__top-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "m24 8.5-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "m18.02 8.207 6.364-.05-.306 6.013",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    className: "av5_expandCollapse_svg__bottom-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "m8.235 24 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "m14.214 24.293-6.364.05.307-6.013",
    strokeLinejoin: "round"
  })))));
};
export { SvgAv5ExpandCollapse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9InJlZ3VsYXIiIHZpZXdCb3g9IjYgNiAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnPgogICAgICAgIDxnIGNsYXNzPSJ0b3AtYXJyb3ciPgogICAgICAgICAgICA8cGF0aCBkYXRhLW5vLWZpbGw9InRydWUiIGQ9Ik0yNCA4LjVMMTggMTQuNSIgc3Ryb2tlPSIjOUI5QUM4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICAgICAgICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTE4LjAyMDUgOC4yMDY3OUwyNC4zODQzIDguMTU2ODlMMjQuMDc3OSAxNC4xNjk5IiBzdHJva2U9IiM5QjlBQzgiCiAgICAgICAgICAgICAgICAgIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgY2xhc3M9ImJvdHRvbS1hcnJvdyI+CiAgICAgICAgICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTguMjM0NzQgMjRMMTQuMjM0NyAxOCIgc3Ryb2tlPSIjOUI5QUM4IiBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICAgICAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICAgICAgICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTE0LjIxNDIgMjQuMjkzMkw3Ljg1MDQ3IDI0LjM0MzFMOC4xNTY4OCAxOC4zMzAxIiBzdHJva2U9IiM5QjlBQzgiCiAgICAgICAgICAgICAgICAgIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";